import { render, staticRenderFns } from "./CopyPath.vue?vue&type=template&id=452f3fae&scoped=true"
import script from "./CopyPath.vue?vue&type=script&lang=ts"
export * from "./CopyPath.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f3fae",
  null
  
)

export default component.exports